import React, { createContext, useContext, useEffect, useState } from 'react'
import ApiService from '../../service/ApiService';
import { useOrder } from '../OrderContext';

export const CategoryContext = createContext()

export const CategoryProvider = ({ children }) => {
  const [categories, setCategories] = useState([])
  const [banners, setBanners] = useState([])
  const [orderDetail] = useOrder()

  const getVendors = async (zoneId) => {
    const params = zoneId ? { zone_id: zoneId } : {}
    const res = await ApiService('/vendors', params, 'get');
    setCategories(res?.data || []);
    setBanners(res?.banners || []);
  }

  useEffect(() => {
    getVendors(orderDetail?.currentLocation);
  }, [orderDetail?.currentLocation])

  return (
    <CategoryContext.Provider value={[categories, banners]}>
      {children}
    </CategoryContext.Provider>
  )
}

export const useCategory = () => {
  const categoryManager = useContext(CategoryContext)
  return categoryManager || [{}]
}
